import request from '../services/request';

export function search(data) {
  return request({
    url: `/admin/search`,
    method: 'POST',
    data,
  });
}

export function searchAdmins(data, page) {
  return request({
    url: `/admin/search?page=${page}`,
    method: 'POST',
    data,
  });
}

export function indexAdmin() {
  return request({
    url: `/admin`,
    method: 'GET',
  });
}

export function getAdminById(id) {
  return request({
    url: `/admin/${id}`,
    method: 'GET',
  });
}

export function storeAdmin(data) {
  return request({
    url: `/admin`,
    method: 'POST',
    data,
  });
}

export function updateAdmin(data, id) {
  return request({
    url: `/admin/${id}`,
    method: 'PUT',
    data,
  });
}

export function deleteAdmin(id) {
  return request({
    url: `/admin/${id}`,
    method: 'DELETE',
  });
}

export function updatePassword(data, id) {
  return request({
    url: `/admin/${id}/password`,
    method: 'PUT',
    data,
  });
}

export function getScopes() {
  return request({
    url: `/admin/scopes`,
    method: 'GET',
  });
}

export function exportFile(data, configs) {
  return request({
    url: `/admin/export`,
    method: 'POST',
    responseType: 'blob',
    data,
    ...configs,
  });
}

export function statusAdmin(id, data) {
  return request({
    url: `/admin/${id}/status`,
    method: 'PUT',
    data,
  });
}
